module.exports = __webpack_public_path__ + "static/media/planner.739ab31c.svg";